import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { toast } from 'react-toastify';
import { InlineSpinner } from "components/Spinner";

function VersionStatus() {
    const [versionData, setVersionData] = useState(null);
    const [waiting, setWaiting] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const versions = await API.get("CdkApi", "/version");
                setVersionData(versions.versions);
                setWaiting(false);
            } catch (error) {
                toast(`There was a problem loading version data`, { type: toast.TYPE.ERROR, autoClose: 5000 });
                console.error('Error retrieving version data', error);
                setWaiting(false);
            }
        })();
    }, [])

    return (
        <table className="table table-striped table-responsive" style={{ width: '100%', marginBottom: '0px', height: 'calc(100vh - 125px)' }}>
            <thead>
                <tr>
                    <th scope="col">
                        <label className="col-form-label p-0">Stack Name</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Branch</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Commit ID</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Deployment Status</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Latest Deployment Timestamp</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Repository</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Username</label>
                    </th>
                    <th scope="col">
                        <label className="col-form-label p-0">Release ID</label>
                    </th>
                </tr>
            </thead>
            <tbody>
                {!versionData &&
                    <tr>
                        <td colSpan="8" className="text-center">{waiting && <InlineSpinner />}</td>
                    </tr>
                }
                {versionData && versionData.map(stack => (
                    <tr key={stack.stack_name}>
                        <td>{stack.stack_name}</td>
                        <td>{stack.branch}</td>
                        <td>{stack.commit_id}</td>
                        <td>{stack.deployment_status}</td>
                        <td>{stack.latest_deployment_timestamp}</td>
                        <td>{stack.repository}</td>
                        <td>{stack.username}</td>
                        <td>{stack.release_id}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default VersionStatus;